<template>
  <b-card>
    <b-form-checkbox id="hideResolved"
              v-model="hideResolved"
              :value="true"
              :unchecked-value="false">
      Hide resolved issues
    </b-form-checkbox>

    <b-tabs style="margin-top:10px">
      <b-tab v-if="groupGeneralErrors.length > 0" title="General Errors" active>
        <recent-reports :hideResolved="hideResolved" :items="groupGeneralErrors"/>
      </b-tab>
      <b-tab v-if="groupServiceIssues.length > 0" title="Service Issues">
        <recent-reports :hideResolved="hideResolved" :items="groupServiceIssues"/>
      </b-tab>
      <b-tab v-if="groupCameraIssues.length > 0" title="Camera Issues">
        <recent-reports :hideResolved="hideResolved" :items="groupCameraIssues"/>
      </b-tab>
      <b-tab v-if="groupPings.length > 0" title="Pings">
        <recent-reports :items="groupPings" :hideResolvedColumn="true"/>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import RecentReports from './RecentReports.vue'

export default {
  props: ['items'],
  components: { RecentReports },
  data() {
    return {
      hideResolved: true
    }
  },
  computed: {
    // recent reports grouped
    groupGeneralErrors() {
      return this.items.filter(r => r.report_type === 'M' || r.report_type === 'E');
    },
    groupServiceIssues() {
      return this.items.filter(r => r.report_type === 'S');
    },
    groupCameraIssues() {
      return this.items.filter(r => r.report_type === 'C');
    },
    groupPings() {
      return this.items.filter(r => r.report_type === 'P');
    }
  }
}
</script>
